module.exports = __webpack_public_path__ + "img/share1.d5db71f8.jpg";